import bolt from "assets/img/icons/illustrations/bolt.png";
import edit from "assets/img/icons/illustrations/edit.png";
import shield from "assets/img/icons/illustrations/shield.png";
import { faCheck, faStar } from "@fortawesome/free-solid-svg-icons";

export type Feature = {
  label: string;
  newBadge?: boolean;
  supported: boolean;
};

export type Pricing = {
  id: number;
  icon: string;
  category: string;
  popular?: boolean;
  monthlyPrice: number;
  yearlyPrice: number;
  link: string;
  features: string[];
  isFree: boolean;
};

export interface PricingAlternate {
  id: number;
  category: string;
  price: number;
  features: string[];
}

export const pricingFeatures = [
  {
    id: "timeline",
    label: "Timeline",
    icon: faCheck,
  },
  {
    id: "adv_search",
    label: "Advanced Search",
    icon: faCheck,
  },
  {
    id: "custom_fields",
    label: "Custom fields",
    new: true,
    icon: faCheck,
  },
  {
    id: "task_dependencies",
    label: "Task dependencies",
    icon: faStar,
  },
  {
    id: "private_teams_projects",
    label: "Private teams & projects",
    icon: faStar,
  },
];

export const pricingItems: Pricing[] = [
  {
    id: 2,
    icon: bolt,
    category: "Essential",
    // popular: true,
    monthlyPrice: 35,
    yearlyPrice: 357,
    features: ["Core CRM"],
    link: "sign-up-paid?type=Essential",
    isFree: false,
  },
  {
    id: 3,
    icon: edit,
    category: "Growth",
    monthlyPrice: 159,
    yearlyPrice: 1377,
    features: ["Core CRM", "KairosIQ"],
    link: "sign-up-paid?type=Growth",
    isFree: false,
  },
];

export const internalPricingItems: any = [
  {
    id: 1,
    icon: bolt,
    category: "Essential",
    description: "Pure CRM for Growing Agents",
    monthlyPrice: 35,
    yearlyPrice: 30,
    features: [
      "Lead Management",
      "Deal Pipeline", 
      "Contact Database",
      "Automated Workflows",
      "Core CRM Features"
    ],
    type: "Essential",
    isFree: false,
    color: "#00d4ff",
    savings: "$63"
  },
  {
    id: 2,
    icon: edit,
    category: "Professional",
    description: "Complete AI Intelligence Platform",
    popular: true,
    monthlyPrice: 250,
    yearlyPrice: 84,
    features: [
      "Everything in Essential",
      "Deal Intelligence Hub",
      "AI Lead Coach & Auto Follow-up",
      "Smart SMS & Email Automation",
      "Team Chat & Collaboration",
      "Advanced Lead Scoring",
      "Pipeline Analytics & Forecasting",
      "Priority Support"
    ],
    addOns: [
      {
        name: "MLS Activation",
        monthlyPrice: 0,
        yearlyPrice: 0,
        oneTimePrice: 150,
        description: "Direct MLS data access — no broker authorization required. Enables property intelligence, retention analytics, AI CMA reports, and buyer portal."
      },
      {
        name: "Virtual Office Number",
        monthlyPrice: 29,
        yearlyPrice: 25,
        description: "Professional phone system with call routing, voicemail, and Twilio integration"
      }
    ],
    type: "Professional",
    isFree: false,
    color: "#00d4ff",
    savings: "$178"
  },
  {
    id: 3,
    icon: shield,
    category: "Premium",
    description: "98% Accurate AI Pricing Model (Phoenix, AZ Only)",
    monthlyPrice: 350,
    yearlyPrice: 127,
    features: [
      "Everything in Professional",
      "Proprietary AI Pricing Model",
      "Institutional-Level Valuations",
      "ARMLS Data Integration",
      "Market Intelligence Dashboard",
      "Competitive Market Analysis",
      "Smart CMA Workflow (Exclusive)",
      "White-Glove Support"
    ],
    addOns: [
      {
        name: "Virtual Office Number",
        monthlyPrice: 29,
        yearlyPrice: 25,
        description: "Professional phone system with call routing, voicemail, and Twilio integration"
      }
    ],
    type: "Premium",
    isFree: false,
    color: "#10b981",
    exclusive: true,
    location: "Phoenix, AZ",
    savings: "$267"
  },
  {
    id: 4,
    icon: shield,
    category: "Broker",
    description: "Complete Brokerage Management Platform (Tier-based pricing)",
    monthlyPrice: 1500, // Starting price - Small tier (0-50 agents)
    yearlyPrice: 1275, // 15% discount on annual billing
    features: [
      "Everything in Premium",
      "Tier-based pricing: Small ($1,500), Medium ($2,000), Large ($2,500)",
      "Agent Management Dashboard",
      "Team Collaboration Tools",
      "Brokerage Analytics & Reporting",
      "Custom Training Materials",
      "Lead Distribution System",
      "Commission Tracking",
      "Compliance & Document Management",
      "Multi-Agent Coordination",
      "Dedicated Broker Support"
    ],
    addOns: [
      {
        name: "Additional Agent Seats",
        monthlyPrice: 70,
        yearlyPrice: 59.50,
        description: "Add unlimited agents to your brokerage at $70/agent/month"
      },
      {
        name: "MLS Integration Package", 
        monthlyPrice: 199,
        yearlyPrice: 169,
        description: "Direct MLS data feeds and automated property updates"
      }
    ],
    type: "BrokerPlan",
    isFree: false,
    color: "#6366f1",
    popular: true,
    brokerFeatures: true,
    savings: "$1,800"
  },
];

export const pricingFeaturesAlternate = [
  {
    id: "create_lead",
    label: "Create Lead up to 30",
    icon: faCheck,
  },
  {
    id: "manage_lead",
    label: "Manage Lead",
    icon: faCheck,
  },
  {
    id: "custom_fields",
    label: "Custom fields",
    new: true,
    icon: faCheck,
  },
  {
    id: "task_dependencies",
    label: "Task dependencies",
    icon: faCheck,
  },
  {
    id: "private_teams_projects",
    label: "Private teams & projects",
    icon: faCheck,
  },
];

export const pricingItemsAlternate: PricingAlternate[] = [
  {
    id: 1,
    category: "Starter",
    price: 15,
    features: ["timeline"],
  },
  {
    id: 2,
    category: "Business",
    price: 23,
    features: ["timeline", "adv_search", "custom_fields"],
  },
  {
    id: 3,
    category: "Enterprise",
    price: 40,
    features: [
      "timeline",
      "adv_search",
      "custom_fields",
      "task_dependencies",
      "private_teams_projects",
    ],
  },
];
